"use strict";
/*jshint esversion: 11 */

import React, {Fragment} from 'react';
import PropTypes from "prop-types";
import CsfMembreNotificationsItem from "./CsfMembreNotificationsItem";

export default function CsfMembreNotificationsTable({notificationsList, notificationIsRead,
                                                      apiUrl,
                                                      apiEnv,
                                                      accessToken
                                                      }) {

  return (
      <div className="inner-wrapper">
        {notificationsList.map((item, index) => (

          <div key={item.CSF_EM_Notification_Id}>
            <CsfMembreNotificationsItem is_read={item.Is_Read}
                                        notificationId={item.CSF_EM_Notification_Id}
                                        attendanceId={item.Attendance_Id}
                                        activityName={item.Attendance_Id__Rn_Descriptor}
                                        html_id={"notif_" + index}
                                        created_date={item.Rn_Create_Date}
                                        title={item.Title}
                                        type={item.Type}
                                        priority={item.Priority_Level}
                                        recognitionCode={item.Recognition_Code}
                                        formation_date={item.Follow_Up}
                                        notificationIsRead={notificationIsRead}
                                        apiUrl={apiUrl}
                                        apiEnv={apiEnv}
                                        accessToken={accessToken}
            />
          </div>

        ))}
      </div>
  )
}

CsfMembreNotificationsTable.propTypes = {
  notificationsList: PropTypes.array.isRequired,
  notificationIsRead: PropTypes.func.isRequired,
  apiUrl: PropTypes.string.isRequired,
  apiEnv: PropTypes.string.isRequired,
  accessToken: PropTypes.string.isRequired,
};
